import { useCallback, useEffect } from "react";

import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import axios from "@/configs/axios";

export const baseSummarizeStatusQueryKey = ["summarizeStatus"];
export const usePostSummarizeStatus = (payload: string, enabled: boolean = false): any => {
  const fetchStatus = useCallback(async () => {
    const url = `${process.env.REACT_APP_SERVER_HOST}/summarize/status?blob_name=${encodeURIComponent(payload)}`;
    try {
      const { data, status } = await axios.get<string>(url, {
        headers: {
          "Cache-Control": "no-store",
        },
      });
      return { data: data, httpStatus: status };
    } catch (error) {
      const { response } = error as AxiosError;
      return { data: response?.data, httpStatus: response?.status };
    }
  }, [payload]);

  const { data } = useQuery({
    queryKey: baseSummarizeStatusQueryKey,
    queryFn: fetchStatus,
    refetchInterval: () => {
      return 2500;
    },
    enabled,
  });

  useEffect(() => {
    if (!data) return;
  }, [data]);
  return data;
};
